import { provideZoneChangeDetection } from "@angular/core";

import '@angular/compiler';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';


registerLocaleData(localeDe);
bootstrapApplication(AppComponent,{...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]} ).catch((err) => console.error(err));


